/**
 * Release sürümü — scripts/sync-app-version.js tarafından üretilir.
 * Build: YYYY-MM-DD.HHmmss | Local: "local"
 * Elle düzenlemeyin.
 */
export const APP_VERSION: string = "2026-09-16.230144";
